import WelcomeSection from '../sections/HomePage/WelcomeSection'
import ServicesSection from '../sections/HomePage/ServicesSection'
import PriceSection from '../sections/HomePage/PriceSection'
import RecommendSection from '../sections/HomePage/RecommendSection'
import PortfolioSection from '../sections/HomePage/Portfolio/PortfolioSection'
import BlogSection from '../sections/HomePage/BlogSection'
import Footer from '../components/elements/Footer'

function HomePage() {
	return (
		<div>
			<WelcomeSection />
			<ServicesSection />
			<PriceSection />
			<RecommendSection />
			<PortfolioSection />
			<BlogSection />
			<Footer />
		</div>
	)
}

export default HomePage
